import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";
import { getConsent, setConsent } from "../lib/tracking";
import { api } from "../lib/api";

const SECTIONS = [
  ["Quem somos", "Este site apresenta o e-book devocional “Quando Faltam Palavras” e suas 50 orações em áudio. O pagamento é processado pela Monetizze, em ambiente próprio dela."],
  ["Quais dados tratamos", "Ao navegar: páginas visitadas, origem do acesso (ex.: utm_source) e dados técnicos do navegador. Ao comprar: a Monetizze nos informa código, status, data e valor da venda. Não armazenamos CPF, endereço, e-mail ou telefone em texto; quando necessário para medir anúncios, e-mail e telefone são transformados em um código irreversível (SHA-256) e descartados após o envio."],
  ["Cookies e ferramentas de medição", "Usamos Pixel da Meta, Google Ads e ferramentas de análise do site. O Pixel de Medição do OpenAI Ads (ChatGPT Ads) só registra eventos após o seu consentimento e utiliza os cookies __oppref (até 30 dias) e __obref (até 1 ano) para relacionar um clique em anúncio a uma compra."],
  ["Para que usamos", "Entender quais anúncios trazem nossas leitoras, medir compras confirmadas e melhorar o site. Não vendemos dados pessoais."],
  ["Compartilhamento", "Monetizze (pagamento e confirmação da venda), Meta, Google e OpenAI (medição de anúncios), sempre limitado ao necessário."],
  ["Prazo de guarda", "Associação entre clique e compra: até 30 dias. Registros técnicos dos avisos de venda: até 90 dias. Registros de vendas, sem dados pessoais, enquanto necessários para controle financeiro."],
  ["Seus direitos (LGPD)", "Você pode solicitar confirmação, acesso, correção ou exclusão de dados, além de revogar o consentimento a qualquer momento nesta página."],
];

function Preferences() {
  const [consent, setLocal] = useState(null);
  useEffect(() => setLocal(getConsent()), []);
  const choose = (v) => { setConsent(v); setLocal(v ? "granted" : "denied"); };
  const label = consent === "granted" ? "Aceitos" : consent === "denied" ? "Recusados" : "Ainda não escolhido";
  return (
    <div data-testid="privacy-preferences" className="rounded-2xl border border-[#E1CE9F] bg-[#FBF5E8] p-5 sm:p-6">
      <div className="flex items-center gap-2">
        <Cookie className="w-5 h-5 text-[#8a6d2f]" />
        <h2 className="font-serif-display text-xl font-semibold">Suas preferências de cookies</h2>
      </div>
      <p className="text-sm text-[#6E5A4F] mt-2">Cookies de medição de anúncios: <strong data-testid="privacy-consent-status">{label}</strong></p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button data-testid="privacy-accept-button" onClick={() => choose(true)} className="rounded-full px-5 py-2 text-sm font-bold text-[#2A1D16] bg-[#C5A059] hover:bg-[#B08B44] transition-colors">Aceitar</button>
        <button data-testid="privacy-reject-button" onClick={() => choose(false)} className="rounded-full px-5 py-2 text-sm font-semibold text-[#6E5A4F] border border-[#E5DCCF] bg-white hover:bg-[#F4EFE6] transition-colors">Recusar</button>
      </div>
    </div>
  );
}

export default function Privacidade() {
  const [email, setEmail] = useState("");
  useEffect(() => { api.get("/config").then((r) => setEmail(r.data?.privacy_email || "")).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#3A2921] font-sans-body">
      <div className="max-w-3xl mx-auto px-5 py-10 sm:py-16">
        <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-1 text-sm text-[#8C7565] hover:text-[#3A2921]"><ArrowLeft className="w-4 h-4" /> Voltar</Link>
        <h1 data-testid="privacy-title" className="font-serif-display font-semibold text-4xl sm:text-5xl mt-4">Política de Privacidade</h1>
        <p className="text-sm text-[#8C7565] mt-2">Última atualização: junho de 2026</p>
        <div className="mt-8"><Preferences /></div>
        <div className="mt-10 space-y-8">
          {SECTIONS.map(([t, body]) => (
            <section key={t}>
              <h2 className="font-serif-display text-2xl font-semibold">{t}</h2>
              <p className="text-[#4A362B] leading-relaxed mt-2">{body}</p>
              {t.startsWith("Seus direitos") && (
                <p data-testid="privacy-contact" className="text-[#4A362B] leading-relaxed mt-2">
                  {email ? <>Contato para assuntos de privacidade: <a data-testid="privacy-contact-email" href={`mailto:${email}`} className="underline text-[#8a6d2f]">{email}</a></> : "Para solicitações, responda ao e-mail de confirmação da sua compra."}
                </p>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
